import React from "react";
import { Routes, Route } from "react-router-dom";
import AssessmentQuestions from "../pages/AssesmentQuestion/AssesmentquestionsComponent/AssessmentQuestion.tsx";
import AdminAssessmentManagement from "../pages/AssesmentQuestion/AdminAssessmentManagement/AdminAssessmentManagement.tsx";
import AssessmentQuestion from "../pages/AssesmentQuestion/AssessmentQuestion.tsx";
import AssessmentSummary from "../pages/AssesmentQuestion/AssesmentSummary/AssessmentSummary.tsx";
import QuestionForm from "../pages/QustionPage/QuestionForm.tsx";
import AssessmentForm from "../pages/AssesmentManagement/AssessmentForm.tsx";
import UserManagement from "../pages/UserManagement/userManagement.tsx";
import KnowledgeHub from "../pages/KnowledgeHub/knowledgehub.tsx";
import AssetCategory from "../pages/AssetCategory/AssetCategory.tsx";
import Assets from "../pages/Assets/assets.tsx";
import Heighlight from "../pages/HeighLight/Heighlights.tsx";
import OtpPage from "../shared/OtpPage/OneTimePassword.tsx";
import NotFound from "../shared/UnDefined/NotFound.tsx";
import AdminLogin from "../shared/Login/LoginPage.tsx";
import MyAccount from "../pages/MyAccount/myAccount.tsx";
import PrivateRoute from "./private-route.tsx";
import PublicRoute from "./public-route.tsx";
import { userType } from "../global/enums.ts";
import RoleAccessGuard from "./RoleAccessGuard.tsx";

const routes = [
  { path: "*", element: <NotFound /> },
  { path: "/", element: <Heighlight /> },
  { path: "/knowledgehub", element: <KnowledgeHub /> },
  {
    path: "/assessments",
    element: <AssessmentQuestion />,
    allowedRoles: [userType.Group, userType.Individual, userType.Guest],
  },
  {
    path: "/assessment-management",
    element: (
      <PrivateRoute>
        <AdminAssessmentManagement />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },
  {
    path: "/assessment/:assessmentId",
    element: (
      <PrivateRoute>
        <AssessmentQuestions />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Group, userType.Individual],
  },
  {
    path: "/assessment-summary",
    element: (
      <PrivateRoute>
        <AssessmentSummary />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Group, userType.Individual],
  },
  {
    path: "/questions",
    element: (
      <PrivateRoute>
        <QuestionForm />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },
  {
    path: "/topics",
    element: (
      <PrivateRoute>
        <AssessmentForm />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },
  {
    path: "/user-management",
    element: (
      <PrivateRoute>
        <UserManagement />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },
    {
    path: "/asset-category",
    element: (
      <PrivateRoute>
        <AssetCategory />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },

  {
    path: "/assets",
    element: (
      <PrivateRoute>
        <Assets />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin],
  },
  {
    path: "/otp",
    element: (
      <PublicRoute restricted={true}>
        <OtpPage />
      </PublicRoute>
    ),
  },
  {
    path: "/admin",
    element: (
      <PublicRoute restricted={true}>
        <AdminLogin />
      </PublicRoute>
    ),
  },
  {
    path: "/my-account",

    element: (
      <PrivateRoute>
        <MyAccount />
      </PrivateRoute>
    ),
    allowedRoles: [userType.Admin, userType.Group, userType.Individual],
  },
];

const AppRoutes: React.FC = () => (
  <Routes>
    {routes.map((route, index) => (
      <Route
        key={index}
        path={route.path}
        element={
          route.allowedRoles ? (
            <RoleAccessGuard allowedRoles={route.allowedRoles}>
              {route.element}
            </RoleAccessGuard>
          ) : (
            route.element
          )
        }
      />
    ))}
  </Routes>
);

export default AppRoutes;
